import { render, staticRenderFns } from "./CreateVersion.vue?vue&type=template&id=6e2ae5d4&"
import script from "./CreateVersion.vue?vue&type=script&lang=js&"
export * from "./CreateVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports